var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaylistIconInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.787 10.8876C22.8524 10.8455 22.9061 10.788 22.9433 10.7203C22.9805 10.6526 23 10.5769 23 10.5C23 10.4231 22.9805 10.3474 22.9433 10.2797C22.9061 10.212 22.8524 10.1545 22.787 10.1124L14.643 5.05645C14.5778 5.01947 14.5039 5 14.4286 5C14.3534 5 14.2795 5.01947 14.2143 5.05645C14.1481 5.09789 14.0937 5.15521 14.0562 5.22302C14.0187 5.29083 13.9994 5.3669 14 5.44407L14 15.5559C13.9994 15.6331 14.0187 15.7092 14.0562 15.777C14.0937 15.8448 14.1481 15.9021 14.2143 15.9436C14.2795 15.9805 14.3534 16 14.4286 16C14.5039 16 14.5778 15.9805 14.643 15.9436L22.787 10.8876Z",
    fill: "#313131"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 2,
    rx: 1,
    fill: "#313131"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#313131"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#313131"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistIconInactive);
export default __webpack_public_path__ + "static/media/playlist-icon-inactive.615aa9327b86def71ea74b240ef687c2.svg";
export { ForwardRef as ReactComponent };